import(/* webpackMode: "eager" */ "/tmp/8dc53baac7ce066/src/app/global-error.tsx")